import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

interface RemoveLockDateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isUpdating: boolean;
}

export const RemoveLockDateModal = ({
  isOpen,
  onClose,
  onConfirm,
  isUpdating,
}: RemoveLockDateModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Remove Lock Date?</Modal.Title>
          <Modal.Close />
        </Modal.Header>

        <Modal.Body>
          <div className="t-text-body-sm t-text-text-60 t-mb-0">
            Deleting the lock date will allow anyone with access to make changes
            to past financial data. This may affect previously closed books,
            reports, and tax filings.
            <br />
            <br />
            Do you want to continue?
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Button onClick={onClose} type="button">
            Go back
          </Button>
          <Button
            customType="danger"
            onClick={onConfirm}
            isLoading={isUpdating}
            disabled={isUpdating}
          >
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
